 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"All":"All","Chat":"Chat","Delivered":"Delivered","Features":"Features","Find-Products-Home~storesDetil~storesMore":"Find-Products-Home~storesDetil~storesMore","Find-Products-Home":"Find-Products-Home","storesMore":"storesMore","ListHistory":"ListHistory","Main":"Main","MakeOffers":"MakeOffers","MakeOffers2":"MakeOffers2","OrdersProcessing":"OrdersProcessing","Products":"Products","WaitingForAllocated~allocatedProducts":"WaitingForAllocated~allocatedProducts","WaitingForAllocated":"WaitingForAllocated","allocatedProducts":"allocatedProducts","WaitingForSourcing":"WaitingForSourcing","al":"al","article":"article","cart":"cart","manageAddresses":"manageAddresses","complete":"complete","cpage~importListHome~importListMain~storesDetil":"cpage~importListHome~importListMain~storesDetil","storesDetil":"storesDetil","cpage":"cpage","importListHome~importListMain~preview":"importListHome~importListMain~preview","importListMain":"importListMain","importListHome":"importListHome","dashboard":"dashboard","details":"details","err404":"err404","guidance":"guidance","hohomepageme~orderpay~ordersManagement~preview":"hohomepageme~orderpay~ordersManagement~preview","hohomepageme":"hohomepageme","preview":"preview","orderpay":"orderpay","ordersManagement":"ordersManagement","home":"home","importSub":"importSub","index~invite":"index~invite","index":"index","invite":"invite","invoices":"invoices","jump":"jump","more":"more","myCustom":"myCustom","order":"order","payList":"payList","products-detail":"products-detail","profile":"profile","reply":"reply","search":"search","select":"select","settings":"settings","stores":"stores","taskList":"taskList","ticket":"ticket","transactionDetail":"transactionDetail"}[chunkId]||chunkId) + "." + {"All":"5b7c1c53","Chat":"37d996ef","Delivered":"f6622d6f","Features":"138783e4","Find-Products-Home~storesDetil~storesMore":"0ed5db88","Find-Products-Home":"b24c11e2","storesMore":"73278d76","ListHistory":"6a103b6e","Main":"b70151e4","MakeOffers":"6354ff19","MakeOffers2":"f9ac0b73","OrdersProcessing":"dc5b81eb","Products":"059cc244","WaitingForAllocated~allocatedProducts":"6ba8c415","WaitingForAllocated":"225f3b4a","allocatedProducts":"653e9348","WaitingForSourcing":"c22bc013","al":"c4dfd308","article":"4c5751ba","cart":"da658ca2","chunk-1e663cb9":"3acb763a","chunk-2d0d79dc":"ce9e74f0","chunk-7c4af082":"da35ad23","chunk-938b96a2":"1cfeb300","chunk-986730aa":"7b323a4f","chunk-aecbf4ae":"c6dffb64","chunk-ea6d39ea":"a58551b6","chunk-ebb609f6":"656b1322","chunk-484f1e91":"24364ccc","manageAddresses":"3864cd74","chunk-ecf319ca":"74418062","complete":"415c37f2","cpage~importListHome~importListMain~storesDetil":"6c5cea2d","storesDetil":"c8a9c547","cpage":"5428a943","importListHome~importListMain~preview":"00ab9032","importListMain":"2271d211","importListHome":"2e7d0c92","dashboard":"4db36e98","details":"51040aa2","err404":"5fde04c0","guidance":"6d648eb2","hohomepageme~orderpay~ordersManagement~preview":"ed674f8f","hohomepageme":"db8aa069","preview":"4a4112d1","orderpay":"02170a52","ordersManagement":"4d79dd91","home":"07a4aa61","importSub":"abe02c76","index~invite":"305fb1ac","index":"f2e15076","invite":"802ce46d","invoices":"4dbdb323","jump":"1a41fc8a","more":"3a09ecb5","myCustom":"4beeaac5","order":"b0a25d41","payList":"4ee28403","products-detail":"74e68f56","profile":"6e835581","reply":"7dc96268","search":"f8ec0110","select":"56679e29","settings":"b5d9a093","stores":"01f00c5e","taskList":"ef58888f","ticket":"76332d46","transactionDetail":"9f1625fe"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"All":1,"Chat":1,"Delivered":1,"Features":1,"Find-Products-Home~storesDetil~storesMore":1,"Find-Products-Home":1,"storesMore":1,"ListHistory":1,"Main":1,"MakeOffers":1,"MakeOffers2":1,"OrdersProcessing":1,"Products":1,"WaitingForAllocated~allocatedProducts":1,"WaitingForAllocated":1,"allocatedProducts":1,"WaitingForSourcing":1,"article":1,"cart":1,"chunk-1e663cb9":1,"chunk-7c4af082":1,"chunk-938b96a2":1,"chunk-986730aa":1,"chunk-aecbf4ae":1,"chunk-ea6d39ea":1,"chunk-ebb609f6":1,"chunk-484f1e91":1,"manageAddresses":1,"chunk-ecf319ca":1,"complete":1,"cpage~importListHome~importListMain~storesDetil":1,"storesDetil":1,"cpage":1,"importListMain":1,"importListHome":1,"dashboard":1,"details":1,"err404":1,"guidance":1,"hohomepageme~orderpay~ordersManagement~preview":1,"hohomepageme":1,"preview":1,"orderpay":1,"ordersManagement":1,"home":1,"importSub":1,"index~invite":1,"index":1,"invite":1,"invoices":1,"jump":1,"more":1,"myCustom":1,"order":1,"products-detail":1,"profile":1,"reply":1,"search":1,"select":1,"settings":1,"stores":1,"taskList":1,"ticket":1,"transactionDetail":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"All":"All","Chat":"Chat","Delivered":"Delivered","Features":"Features","Find-Products-Home~storesDetil~storesMore":"Find-Products-Home~storesDetil~storesMore","Find-Products-Home":"Find-Products-Home","storesMore":"storesMore","ListHistory":"ListHistory","Main":"Main","MakeOffers":"MakeOffers","MakeOffers2":"MakeOffers2","OrdersProcessing":"OrdersProcessing","Products":"Products","WaitingForAllocated~allocatedProducts":"WaitingForAllocated~allocatedProducts","WaitingForAllocated":"WaitingForAllocated","allocatedProducts":"allocatedProducts","WaitingForSourcing":"WaitingForSourcing","al":"al","article":"article","cart":"cart","manageAddresses":"manageAddresses","complete":"complete","cpage~importListHome~importListMain~storesDetil":"cpage~importListHome~importListMain~storesDetil","storesDetil":"storesDetil","cpage":"cpage","importListHome~importListMain~preview":"importListHome~importListMain~preview","importListMain":"importListMain","importListHome":"importListHome","dashboard":"dashboard","details":"details","err404":"err404","guidance":"guidance","hohomepageme~orderpay~ordersManagement~preview":"hohomepageme~orderpay~ordersManagement~preview","hohomepageme":"hohomepageme","preview":"preview","orderpay":"orderpay","ordersManagement":"ordersManagement","home":"home","importSub":"importSub","index~invite":"index~invite","index":"index","invite":"invite","invoices":"invoices","jump":"jump","more":"more","myCustom":"myCustom","order":"order","payList":"payList","products-detail":"products-detail","profile":"profile","reply":"reply","search":"search","select":"select","settings":"settings","stores":"stores","taskList":"taskList","ticket":"ticket","transactionDetail":"transactionDetail"}[chunkId]||chunkId) + "." + {"All":"8f20a140","Chat":"93023fba","Delivered":"66a7bad7","Features":"74769fdd","Find-Products-Home~storesDetil~storesMore":"86592b7b","Find-Products-Home":"c36f857c","storesMore":"dad65b0e","ListHistory":"2525a29b","Main":"e945383d","MakeOffers":"622e0ec6","MakeOffers2":"0a584154","OrdersProcessing":"5d589b6d","Products":"48687ebb","WaitingForAllocated~allocatedProducts":"8e4cb66f","WaitingForAllocated":"7b34625f","allocatedProducts":"70c1b2d9","WaitingForSourcing":"fd607cca","al":"31d6cfe0","article":"e55c8341","cart":"d68af74d","chunk-1e663cb9":"927402cc","chunk-2d0d79dc":"31d6cfe0","chunk-7c4af082":"617fdd67","chunk-938b96a2":"c9a41644","chunk-986730aa":"5049ade9","chunk-aecbf4ae":"d129c3a1","chunk-ea6d39ea":"7063bdea","chunk-ebb609f6":"4cebd7d6","chunk-484f1e91":"d635ad9b","manageAddresses":"20d7a562","chunk-ecf319ca":"dee60468","complete":"1e6a8fed","cpage~importListHome~importListMain~storesDetil":"59e38391","storesDetil":"17398daa","cpage":"c02b65e3","importListHome~importListMain~preview":"31d6cfe0","importListMain":"46a406df","importListHome":"4cb632b2","dashboard":"f735c271","details":"00425174","err404":"da4dc052","guidance":"c3c48fe2","hohomepageme~orderpay~ordersManagement~preview":"ef2ec854","hohomepageme":"5f58bae3","preview":"490ecebf","orderpay":"a0e75852","ordersManagement":"5c383dfc","home":"55a3ccd5","importSub":"569ffaaa","index~invite":"b2bf7705","index":"7b815d95","invite":"bdb6d907","invoices":"d8dbf901","jump":"e45bf345","more":"7c16240c","myCustom":"70296c14","order":"7c6bca1f","payList":"31d6cfe0","products-detail":"83aa021e","profile":"89e28a54","reply":"37d725fa","search":"1279b0c8","select":"cd4bd15c","settings":"6b82a210","stores":"c4d9cb2a","taskList":"6ee6c819","ticket":"e230ad0d","transactionDetail":"f774b70d"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
